import { Switch } from '@mantine/core';

import TwoFAModal from './TwoFAModal';

import { useModal } from '@/hooks/useModal';
import { useTfa } from '../../hooks/useTfa';
import { useAuth } from '@/hooks/useAuth';
import { useToast } from '@/hooks/useToast';

interface TFAProps {
  enabled: boolean;
  createMessage: (msg: string, options: any) => void;
}

const TwoFA = ({ enabled, createMessage }: TFAProps) => {
  const { Modal, modalProps, openModal, closeModal } = useModal();
  const { createToast } = useToast();
  const { tokenInfo, setTokenInfo, setUserInfo } = useAuth();

  const onTfaToggleSuccess = (tfa: boolean, message: string) => {
    setTokenInfo({ enabled_2fa: tfa });
    setUserInfo({ twofa_activated: tfa });
    createMessage(`2FA Successfully ${message}`, { type: 'success' });
    closeModal();
  };

  const { generateTFA, activateTFA, deactivateTFA, TFAData, disableButton } = useTfa({
    onActivateSuccess: (tfa) => onTfaToggleSuccess(tfa, 'activated'),
    onDeactivateSuccess: (tfa) => onTfaToggleSuccess(tfa, 'deactivated'),
    onGenerateSuccess: () => {
      openModal();
    },
    onGenerateError: (error?: string) => {
      createToast(error || 'We are sorry, something went wrong.', 'error');
    },
    username: tokenInfo.sub,
  });

  const onToggle = enabled ? openModal : generateTFA;
  const tfaAction = enabled ? deactivateTFA : activateTFA;

  return (
    <>
      <Switch
        checked={enabled}
        onChange={() => onToggle()}
        disabled={disableButton}
        aria-label={enabled ? 'Deactivate 2FA' : 'Activate 2FA'}
        size="sm"
      />

      {(TFAData || enabled) && (
        <Modal
          {...modalProps}
          title={`${enabled ? 'Deactivate' : 'Activate'} Two-Factor Authentication`}
          size="500px"
        >
          <TwoFAModal
            enabled={enabled}
            data={TFAData}
            tfaAction={tfaAction}
            disableAction={disableButton}
          />
        </Modal>
      )}
    </>
  );
};

export default TwoFA;
